<template>
  <Table v-if="validFollowUpOrderTypes">
    <template #header>
      <th>{{ $t('meta.orderType') }}</th>
      <th>{{ $t('meta.followUpOrderType') }}</th>
    </template>
    <template #body>
      <tr v-for="[orderType, optionsForFollowUpOrderTypes] in Object.entries(validFollowUpOrderTypes)" :key="orderType">
        <td>{{ $t(labelForOrderType(orderType)) }}</td>
        <td>
          <v-select
            :placeholder="$t('meta.pleaseSelect')"
            :options="mapOptions(optionsForFollowUpOrderTypes)"
            :value="getValue(orderType)"
            :reduce="option => option.value"
            @input="value => setValue(orderType, value)"
          />
        </td>
      </tr>
    </template>
  </Table>
</template>

<script>
import Table from '@/components/Table/index.vue'
import stringUtils from '@/components/mixins/stringUtils'

import configApi from '@/api/config'

export default {
  name: 'FollowUpOrderTypes',
  components: {
    Table,
  },
  props: {
    value: { type: Object },
  },
  data: () => ({
    validFollowUpOrderTypes: null,
  }),
  mixins: [stringUtils],
  methods: {
    mapOptions(options) {
      return options.map(option => {
        return {
          label: this.$t(this.labelForOrderType(option)),
          value: option,
        }
      })
    },
    getValue(key) {
      return this.value?.[key]
    },
    setValue(key, value) {
      if (value == null) {
        // the backend expects the key to not even be set at all
        const newValue = Object.assign({}, this.value)
        delete newValue[key]

        this.$emit('input', newValue)
      } else {
        this.$emit('input', { ...this.value, [key]: value })
      }
    },
  },
  async mounted() {
    const configData = await configApi.get()
    this.validFollowUpOrderTypes = configData.valid_follow_up_order_types
  },
}
</script>

<style lang="scss">
.form-control-container {
  .table {
    border-bottom-color: transparent;
    tr:last-child td {
      border-color: transparent;
    }
  }
  .table.layout-fixed td {
    overflow: visible;
  }
}
</style>
